import { create } from "zustand";

import type { Role } from "@/data/types";

interface TweaksState {
  role: Role;
  aiStep: number;
  showOnaScenario: boolean;
  setRole: (role: Role) => void;
  setAiStep: (step: number) => void;
  setShowOnaScenario: (show: boolean) => void;
  /** 키-값 쌍으로 일괄 설정 */
  setTweak: <K extends "role" | "aiStep" | "showOnaScenario">(
    key: K,
    value: TweaksState[K],
  ) => void;
}

/** 데모 조절 패널 (역할, AI 단계, 시나리오 표시) */
const useTweaksStore = create<TweaksState>((set) => ({
  role: "admin",
  aiStep: 4,
  showOnaScenario: true,
  setRole: (role) => set({ role }),
  setAiStep: (aiStep) => set({ aiStep }),
  setShowOnaScenario: (showOnaScenario) => set({ showOnaScenario }),
  setTweak: (key, value) => set({ [key]: value }),
}));

export { useTweaksStore };
export type { TweaksState };
